<div id="add-review-comments-dialog" class="add-review-comments-dialog">
    <div mat-dialog-title>
        <div class="row">
            <div class="col-md-10">
                <h3>Review Comments</h3>
            </div>
            <div class="col-md-2">
                <span class="fa fa-close action-icons float-right ml-auto" (click)="close()"></span>
            </div>
        </div>
    </div>

    <div mat-dialog-content>
        <form [formGroup]="reviewForm" (ngSubmit)="onSave(reviewForm.value)" novalidate>
            <div id="{{appName}}-app" class="form-group review-comment-dialog-content">
                <mat-card style="margin: 15px 15px 30px 15px;" *ngIf="reviewCommentList && reviewCommentList.length>0" [ngStyle]="{'visibility':reviewCommentList.length>0?'visible':'hidden'}">
                    <mat-list>
                        <section>
                            <mat-list-item *ngFor="let review of reviewCommentList;let i=index;">
                                <div class="d-flex">
                                    <div class="m-auto">
                                        <button [matTooltip]="review.reviewedBy" color="warn" class="review-comment-icon" mat-mini-fab aria-label="Example icon button with a vertical three dot icon">
                                            <span class="information-text" style="color:white;">{{review.displayName}}</span>
                                        </button>
                                    </div>
                                    <div style="display: grid;">
                                        <div class="review-comment-text ml-3 text-left">{{review.reviewComment}}</div>
                                        <div class="review-comment-sub-text color-gray ml-3 mb-2">Review Date : {{review.reviewDate}}</div>
                                    </div>
                                </div>
                                <br>
                                <mat-divider *ngIf="i != reviewCommentList.length-1"></mat-divider>
                            </mat-list-item>
                        </section>
                    </mat-list>
                </mat-card>


                <div class="row ml-1">
                    <div class="col-10">
                        <mat-form-field appearance="outline" class="col-12 p-0">
                            <mat-label>{{"Label.review_comment" | translate}} :</mat-label>
                            <textarea matInput required placeholder="Review Comments" formControlName="comment" ngDefaultControl></textarea>
                            <mat-error *ngIf="hasError('comment', 'required')">Comment is required</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-2">
                        <button matTooltip="Add Review Comments" [ngStyle]="{opacity : !reviewForm.valid ?  '0.5':'1'}" [disabled]="!reviewForm.valid"
                            (click)="onSave(reviewForm.value)" color="warn" mat-fab aria-label="Example icon button with a heart icon"
                            class="review-comment-icon">
                            <mat-icon aria-hidden="false" aria-label="Example home icon">add_box</mat-icon>
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </div>

</div>